(function () {
    'use strict';

    angular
        .module('commons')
        .service('VersionService', VersionService);

    function VersionService(AppVersion) {
        var vm = this;

        vm.getVersion = getVersion;
        vm.getFullVersionInfo = getFullVersionInfo;


        function getVersion() {
            return AppVersion.VERSION;
        }

        function getFullVersionInfo() {
            return {
                version: AppVersion.VERSION,
                name: 'AeroLineAdmin'
            };
        }
    }
}());
